import React from 'react'
import {   Field} from 'redux-form'

const svinputRenderField = ({input, label, type, meta:{error, touched}})=>{
    return(
            <input {...input}  component="input" type="input"   className="form-control" /> 
    )

}
export class SVCPOInputEp extends React.Component{

    constructor(props){
        super(props)
    }
  
    componentWillReceiveProps(next){
        console.log('props changed SVString')
    }
   
    render(){
        console.log('render countryCallingCode')
        console.log(this.props)
        const {isdcodeTypes} = this.props
        let me = this
       let {member,index, placeholder ='Port Z'} = this.props
         /*  
           
                                                <Field
            name={`${member}.countryCallingCode`}
            type="text"
            component={svinputRenderField}
            placeholder={placeholder}
            className="form-control"
           
          />
            */
            

          return (
            
   

                <Field  
                component="select" 
                id={`${member}.countryCallingCode`}
                name={`${member}.countryCallingCode`}
                className="form-control" >
                                                
                                                <option value="">Select PhoneCalling /ISD Code</option>
                                                    {
                                        
                                                
                                        isdcodeTypes.map(  (o, idx)=>(  <option value={o.dial} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
    
                     </Field>    
                                  
          
           )
    }
}